module.exports = {"id":"220905","name":"Jean-Eudes Aholou","rating":"71","photo":"./data/images/photos/1/220905.png","club":{"name":"RC Strasbourg","logo":"./data/images/clubs/RCStrasbourg.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Jean-EudesAholou0.json
// module id = 1953
// module chunks = 0